import axios from 'axios';

const updateProductSelect = function (productTypeId, productSelect) {
  axios
    .get('/products_by_product_type', {
      params: { product_type_id: productTypeId },
    })
    .then(response => {
      productSelect.find('option').not(':first').remove();
      $.each(response.data, function (_, p) {
        productSelect.append(
          $('<option>', {
            text: p.code_and_name,
            value: p.id,
          })
        );
      });
      productSelect.trigger('change');
    });
};

const updateProductSubtypes = function (productTypeId, productSubtypeSelect) {
  axios
    .get('/subtypes_by_product_type', {
      params: { product_type_id: productTypeId },
    })
    .then(response => {
      productSubtypeSelect.find('option').not(':first').remove();
      $.each(response.data, function (_, p) {
        productSubtypeSelect.append(
          $('<option>', {
            text: p.name,
            value: p.id,
          })
        );
      });
      productSubtypeSelect.trigger('change');
    })
    .catch(error => {
      console.log(error.response.data);
    });
};

document.addEventListener('turbolinks:load', function () {
  // lot_transactions report
  $('#report_product_lot_ids_1').select2({
    placeholder: 'Buscar un lote de producto (código o producto)',
    minimumInputLength: 3,
    width: '100%',
  });
  $('#report_product_ids_5').select2({
    placeholder: 'Buscar un producto (código o nombre)',
    minimumInputLength: 3,
    width: '100%',
  });

  const updateProductLotSelectByType = function () {
    const productTypeId = $('#report_product_type_1').val();
    const lotSelect = $('#report_product_lot_ids_1');
    axios
      .get('/product_lots_by_product_type', {
        params: { product_type_id: productTypeId },
      })
      .then(response => {
        lotSelect.find('option').not(':first').remove();
        $.each(response.data, function (_, lot) {
          lotSelect.append(
            $('<option>', {
              text: lot.code_and_product,
              value: lot.id,
            })
          );
        });
        lotSelect.trigger('change');
      });
  };

  const updateProductLotSelectByProduct = function () {
    const productIds = $('#report_product_ids_5').val();
    const lotSelect = $('#report_product_lot_ids_1');
    if (productIds !== null) {
      axios
        .get('/product_lots_by_products', {
          params: { product_ids: productIds },
        })
        .then(response => {
          lotSelect.find('option').not(':first').remove();
          $.each(response.data, function (_, lot) {
            lotSelect.append(
              $('<option>', {
                text: lot.code_and_product,
                value: lot.id,
              })
            );
          });
          lotSelect.trigger('change');
        });
    }
  };

  $('#report_product_type_1').on('change', function () {
    const productTypeId = $('#report_product_type_1').val();
    const productSelect = $('#report_product_ids_5');
    const productSubtypeSelect = $('#report_product_subtype_1');
    updateProductSelect(productTypeId, productSelect);
    updateProductSubtypes(productTypeId, productSubtypeSelect);
    updateProductLotSelectByType();
  });
  $('#report_product_ids_5').on('change', updateProductLotSelectByProduct);

  // simple_stock report
  $('#report_product_ids_2').select2({
    placeholder: 'Buscar un producto (código o nombre)',
    minimumInputLength: 3,
    width: '100%',
  });
  $('#report_product_type_2').on('change', function () {
    const productTypeId = $('#report_product_type_2').val();
    const productSubtypeSelect = $('#report_product_subtype_2');
    updateProductSubtypes(productTypeId, productSubtypeSelect);
  });
  $(
    '#report-by-plant-7, #lot-products-dropdown, #lot-ingredients-dropdown, #report-by-merchandise-owner'
  ).hide();
  $('#by_plant_check_7').on('click', function () {
    $('#report-by-plant-7').toggle(this.checked);
  });
  $('#by-selected-products-check').on('click', function () {
    $('#lot-products-dropdown').toggle(this.checked);
  });
  $('#by-merchandise-owner-check').on('click', function () {
    $('#report-by-merchandise-owner').toggle(this.checked);
  });

  // simple_stock_projection report
  $('#report-by-maquila-1').hide();
  $('#by_maquila_check_1').on('click', function () {
    $('#report-by-maquila-1').toggle(this.checked);
  });

  // valuable_iventory report
  $('#report_product_ids_6').select2({
    placeholder: 'Buscar un producto (código o nombre)',
    minimumInputLength: 3,
    width: '100%',
  });
  $('#report_product_ids_7').select2({
    placeholder: 'Todas',
    width: '100%',
  });
  $('#report_warehouse_ids').select2({
    placeholder: 'Buscar un almacén (código o nombre)',
    minimumInputLength: 3,
    width: '100%',
  });
  $('#report_area_ids').select2({
    placeholder: 'Buscar un área (código o descripción)',
    minimumInputLength: 3,
    width: '100%',
  });

  $('#report_product_type_3').on('change', function () {
    const productTypeId = $('#report_product_type_3').val();
    const productSelect = $('#report_product_ids_6');
    const productSubtypeSelect = $('#report_product_subtype_3');
    updateProductSelect(productTypeId, productSelect);
    updateProductSubtypes(productTypeId, productSubtypeSelect);
  });
});
